'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelWrapperStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var positionMap = {
  top: {
    order: 1,
    opposite: 'bottom'
  },
  bottom: {
    order: 3,
    opposite: 'top'
  }
};

var align = function align(_ref) {
  var labelAlign = _ref.labelAlign;
  return 'text-align: ' + labelAlign + ';';
};

var position = function position(_ref2) {
  var labelPositionY = _ref2.labelPositionY,
      progressType = _ref2.progressType,
      themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var labelPadding = theme.reactackle.components.progress.circle.labelCenteredPadding;

  var spacing = labelPositionY !== 'center' ? theme.reactackle.components.progress[progressType].labelSpacing[labelPositionY] : null;

  return labelPositionY !== 'center' ? (0, _styledComponents.css)(['order:', ';margin-', ':', ';'], positionMap[labelPositionY].order, positionMap[labelPositionY].opposite, (0, _reactackleCore.getValueString)(spacing)) : '\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: center;\n    padding: ' + (0, _reactackleCore.getValueString)(labelPadding) + ';\n    word-wrap: break-word;\n  ';
};

var LabelWrapperStyled = exports.LabelWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'LabelWrapperStyled'
})(['', ' ', ''], align, position);

LabelWrapperStyled.displayName = 'LabelWrapperStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-progress/dist/ProgressBase/styles/LabelWrapperStyled.js
// module id = 770
// module chunks = 0